export const get_report = (state) => state.report;
export const get_reports = (state) => state.reports;
export const get_question = (state) => state.question;
export const get_questions = (state) => state.questions;
export const get_user_categories = (state) => state.user_categories;
